import React from 'react';
import { IonContent, IonHeader, IonPage, IonToolbar, IonButtons, IonBackButton, IonTitle } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import GolfResultScreen from '@/components/game-result/GameResult';

const GameResultPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/dashboard" />
          </IonButtons>
          <IonTitle>{t('game_results')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <GolfResultScreen />
      </IonContent>
    </IonPage>
  );
};

export default GameResultPage;
